
import styled from "styled-components"

export const ContainerFull = styled.div`
    width: 100%;
    //max-width: 1200px;
    margin: 0 auto;
`;